import scriptLoader from '../services/script-loader.js';

const initPlayer = (articleId, projectId, isInfinite) =>
  new BeyondWords.Player({
    target: `#audio-player-${articleId}`,
    projectId,
    sourceId: articleId,
    clientSideEnabled: !isInfinite,
    widgetMargin: `0 0 100px 16px`,
  });

export const initBeyondWords = (article, isInfinite = false) => {
  const articleId = article.data.id;
  const placeholder = article.$root.querySelector(`#audio-player-${articleId}`);

  if (placeholder) {
    const projectId = Number(placeholder.dataset.projectId);

    if (!window.BeyondWords?.Player) {
      scriptLoader(`https://proxy.beyondwords.io/npm/@beyondwords/player@0.3.17/dist/umd.js`, () =>
        initPlayer(articleId, projectId, isInfinite),
      );
    } else {
      initPlayer(articleId, projectId, isInfinite);
    }
  }
};
